<template>
	<main class="SelectProperty">
		<v-card class="SelectProperty_card">
			<div class="d-flex align-center">
				<aside
					class="SelectProperty_aside"
					v-show="total_properties > 1"
				>
					<div class="">
						<v-combobox
							:items="properties"
							:return-object="false"
							item-text="property_name"
							item-value="property_seoname"
							:placeholder="
								property_selected.length < 1
									? 'Select your Property'
									: ''
							"
							hide-selected
							v-model="property_selected"
						>
							<template v-slot:selection="{ item }">
								<span>{{
									getPropertyNameBySeoname(item)
								}}</span>
							</template>
						</v-combobox>

						<v-combobox
							v-if="user.isSuperUser && users.length > 0"
							:items="users"
							:return-object="false"
							item-text="fullname"
							item-value="admin_id"
							:placeholder="
								user_simulated.length < 1
									? 'Simulate a User'
									: ''
							"
							hide-selected
							v-model="user_simulated"
							@change="onChangeHandler"
						>
							<template v-slot:selection="{ item }">
								<span :key="item">{{ item }}</span>
							</template>
						</v-combobox>
					</div>

					<img
						class="SelectProperty_brand"
						src="@/assets/img/logo-winmore1.svg"
						alt="Logo Venuelocity Win More"
					/>
				</aside>

				<section
					v-if="!['', 'all'].includes(property_selected)"
					class="SelectProperty_portals"
				>
					<div class="d-flex justify-center">
						<article
							:class="['SelectProperty_portals-item']"
							v-for="logo in property_logos"
							:key="logo.type"
						>
							<div 
								class="SelectProperty_portals-item-label"
								:class="{'isDisabled': isButtonDisabled(logo.type)}"
							>
								{{ logo.label }}
							</div>	
							<!-- <img
								:src="logo.file"
								:alt="logo.alt"
								:class="isLogoDisabled(logo.type) && 'disabled'"
							/> -->
							<v-btn
								:disabled="isButtonDisabled(logo.type)"
								color="primary"
								@click="changeSiteId(logo.type)"
								link
								>Enter</v-btn
							>
							<a
								v-if="isButtonDisabled(logo.type)"
								class="link"
								href="https://www.venuelocity.com/"
								target="_blank"
								>Contact Us</a
							>
						</article>
					</div>
				</section>
			</div>
		</v-card>
	</main>
</template>

<script>
import { RouterLink } from "vue-router";
import { mapGetters, mapActions } from "vuex";
import meetingsLogo from "@/assets/img/logo-meetings2.svg";
import weddingsLogo from "@/assets/img/logo-weddings2.svg";

export default {
	name: "SelectProperty",
	components: { RouterLink },
	data() {
		return {
			properties: [],
			sites: [],
			property_logos: [
				{
					type: 12,
					/* alt: "Weddings Logo",
					file: weddingsLogo, */
					label: "Weddings",
				},
				{
					type: 13,
					/* alt: "Meetings Logo",
					file: meetingsLogo, */
					label: "Meetings",
				},
				{
					type: 11,
					/* alt: "Social Logo",
					file: meetingsLogo,	 */
					label: "Social Events",
				}
			],
			properties_options: [],
			user_simulated: "",
		};
	},
	async beforeMount() {
		const properties = await this.getProperties();
		//this.properties = (this.user.isSuperUser)?[{property_name:'All',property_seoname:'all'}].concat(properties):properties;
		this.properties = properties;

		this.properties_options = properties.map((property) => ({
			label: property.property_name,
			value: property.property_seoname,
		}));

		if (this.total_properties == 1) {
			this.$router.push("/dashboard");
		}

		if (this.property_selected != "" && this.property_selected != "all") {
			this.sites = this.properties.find((property) => {
				return property.property_seoname == this.property_selected;
			}).sites;
		}

		this.$store.commit('setNewSearch', '');
	},
	computed: {
		...mapGetters({
			total_properties: "StateTotalProperties",
			user: "StateUser",
			users: "StateUsersList",
		}),
		property_selected: {
			get() {
				return this.$store.getters.StatePropertySeleted;
			},
			set(value) {
				this.$store.commit("setPropertySeleted", value);
				if (["all"].includes(value)) {
					this.$router.push("/dashboard-admin");
					this.$store.commit("setSiteSelected", -1);
					this.$store.commit("setShowTotalRev", false);
					this.$store.commit("setShowFeesInv", false);
					this.$store.commit("setShowOutbound", false);
				} else {
					this.sites = this.properties.find((property) => {
						return property.property_seoname == value;
					}).sites;
					this.$store.commit("setSites", this.sites);
				}
			},
		},
		site_selected: {
			get() {
				return this.$store.getters.StateSiteSeleted;
			},
			set({ site_id, property_type }) {

				const site = this.sites.find(
					(s) => s.site_id === site_id && s.property_type === property_type
				);

				if (!site) return;

				this.$store.commit("setTypeSelected", site.property_type);
				this.$store.commit("setShowTotalRev", site.showTotalRev);
				this.$store.commit("setShowFeesInv", site.showFeesInv);
				this.$store.commit("setShowOutbound", site.showOutbound);
				this.$store.commit("setSiteSelected", site_id);
			},
		},
	},
	methods: {
		...mapActions(["getProperties", "getUser"]),
		/* isLogoDisabled(propertyType) {
			return !this.sites.some(
				(site) => site.property_type == propertyType
			);
		}, */
		isButtonDisabled(propertyType) {
			return !this.sites.some(
				(site) => site.property_type == propertyType
			);
		},
		changeSiteId(propertyType) {
			const site = this.sites.find(
				(site) => site.property_type == propertyType
			);

			this.site_selected = {
				site_id: site.site_id,
				property_type: site.property_type
			};

			this.$router.push({
				name: "Dashboard",
				params: { siteId: this.site_selected },
			});
		},
		getPropertyNameBySeoname(seoname = "") {
			const properties = this.properties;
			if (properties.length > 0) {
				return properties.find(
					(property) => property.property_seoname == seoname
				).property_name;
			}
		},
		async onChangeHandler() {
			const userData = new FormData();
			userData.append("id", this.user_simulated);
			const processChange = await this.getUser(userData);

			if (processChange.status === 200) {
				this.properties = await this.getProperties();

				if (this.total_properties == 1) {
					this.$store.commit(
						"setPropertySeleted",
						this.properties[0].property_seoname
					);
					this.$store.commit("setSites", this.properties[0].sites);
					this.$store.commit(
						"setSiteSelected",
						this.properties[0].sites[0].site_id
					);
					this.$store.commit(
						"setTypeSelected",
						this.properties[0].sites[0].property_type
					);
					this.$store.commit(
						"setShowTotalRev",
						this.properties[0].sites[0].showTotalRev
					);
					this.$store.commit(
						"setShowFeesInv",
						this.properties[0].sites[0].showFeesInv
					);
					this.$store.commit(
						"setShowOutbound",
						this.properties[0].sites[0].showOutbound
					);
					this.$router.push("/dashboard");
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/scss/colors.scss";
.SelectProperty {
	display: grid;
	place-items: center;
	width: 100%;
	height: auto;
	min-height: 100vh;
	padding: 30px;
	&_card {
		display: block;
		width: 100%;
		max-width: 1120px;
	}
	&_aside {
		background: $purple;
		color: #fff;
		display: grid;
		place-items: center;
		width: 40%;
		max-width: 440px;
		height: auto;
		padding: 20px;
		min-height: 500px;
		position: relative;
		select {
			background: url("~@/assets/img/arrow-select1-white.svg") no-repeat
				right center / 15px auto;
			font-size: 23px;
			color: inherit;
			display: block;
			width: 100%;
			max-width: 260px;
		}
		/deep/ .v-select {
			color: inherit;
			width: 100%;
			max-width: 260px;
			&__selections {
				color: #fff !important;
				background: url("~@/assets/img/arrow-select1-white.svg")
					no-repeat right center / 15px auto;
				font-size: 23px;
				input {
					color: #fff !important;
					font-size: 23px;
					caret-color: auto;
					&::placeholder {
						color: inherit !important;
					}
				}
			}
			.v-input__slot::before,
			.v-input__slot::after {
				display: none;
			}
			.v-input__append-inner {
				display: none;
			}
		}
		img {
			display: block;
			width: auto;
			max-width: 100%;
			margin: 50px 0;
			position: absolute;
			bottom: 0;
			left: 50%;
			z-index: 1;
			transform: translateX(-50%);
		}
	}
	&_portals {
		flex: 1 1;
		&-item {
			flex: 1 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 20px;
			padding: 20px;
			padding-top: 60px;
			border-right: 2px solid #f5f5f5;
			&:last-child {
				border-right: none;
			}
			img {
				display: block;
				width: auto;
				max-width: 100%;
				height: auto;
				max-height: 30px;
				object-fit: contain;
				&.disabled {
					filter: grayscale(1);
					opacity: 0.4;
					pointer-events: none;
				}
			}
			&-label {
				font-size: 23px;
				&.isDisabled {
					pointer-events: none;
					opacity: 0.4;
				}
			}
		}
		.v-btn {
			min-width: 140px;
		}
		.link {
			font-size: 14px;
			color: #b4b4b4;
			display: inline-block;
			margin-top: 0.5em;
			@media screen and (min-width: 960px) {
				&:hover {
					color: $purple;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/SelectProperty.vue